import React, { MouseEvent } from 'react';
import cx from 'classnames';
import { Radio } from '@xarvio/radio';

import styles from './Selectable.module.scss';

export interface SelectableProps {
  selected?: boolean;
  disabled?: boolean;
  theme?:
    | 'white'
    | 'light'
    | 'darker'
    | 'border'
    | 'blue'
    | 'lighter'
    | 'border-blue-dark'
    | 'border-blue-dark-radio'
    | 'border-blue-dark-radio-on-selected'
    | 'border-blue-white-radio'
    | 'grey-200'
    | 'grey-800'
    | 'grey-transparent';
  className?: string;
  seleniumAttribute?: string;
  onClick?: (e?: MouseEvent<HTMLElement>) => void;
}

export const Selectable: React.FC<React.PropsWithChildren<SelectableProps>> = ({
  selected,
  disabled,
  theme,
  className,
  children,
  seleniumAttribute,
  onClick,
}) => {
  const classNames = cx(styles.selectable, className, {
    [styles.selectable_selected]: selected,
    [styles.selectable_active]: !disabled,
    [styles.selectable_disabled]: disabled,
    [styles[`selectable_theme-${theme}`]]: theme,
  });

  return (
    <div
      className={classNames}
      {...(onClick && !disabled ? { onClick } : {})}
      data-selenium={seleniumAttribute}
    >
      {(theme === 'border-blue-dark-radio' ||
        theme === 'border-blue-white-radio' ||
        theme === 'border-blue-dark-radio-on-selected') && (
        <Radio
          isSelected={selected}
          isDisabled={disabled}
          className={styles.selectableRadio}
        />
      )}
      {children}
    </div>
  );
};
